import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import AuthRight from "./AuthRight";
import { registerUser } from "../../Redux/Actions/authActions";


function Signup({ registerUser }) {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        name: "",
        mobileNumber: "",
        gender: "",
        agentId: "",
        referedBy: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            // Validate all required fields
            if (!formData.name || !formData.email || !formData.mobileNumber || !formData.password || !formData.agentId || !formData.gender) {
                setError("All fields are required. Please fill in all the information.");
                setLoading(false);
                return;
            }

            const userData = {
                name: formData.name.trim(),
                email: formData.email.trim(),
                mobileNumber: formData.mobileNumber.trim(),
                password: formData.password,
                gender: formData.gender,
                agentId: formData.agentId.trim(),
                referedBy: formData.referedBy.trim() || undefined,
            };

            const result = await registerUser(userData);
            
            if (result.success) {
                navigate(process.env.PUBLIC_URL + "/");
            } else {
                setError(result.error || "Registration failed. Please try again.");
            }
        } catch (err) {
            setError("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="body d-flex p-0 p-xl-5">
                <div className="container">
                    <div className="row g-3">
                        <div className="col-lg-6 d-flex justify-content-center align-items-center auth-h100">
                            <div className="d-flex flex-column">
                                <h1>Create Your Account</h1>
                                <span className="text-muted">Please fill in all the required information to register</span>
                                <div className="card mt-4">
                                    <div className="card-body p-4">
                                        {error && (
                                            <div className="alert alert-danger" role="alert">
                                                {error}
                                            </div>
                                        )}
                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <label className="form-label fs-6">Full Name <span className="text-danger">*</span></label>
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fs-6">Email address <span className="text-danger">*</span></label>
                                                <input 
                                                    type="email" 
                                                    className="form-control"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fs-6">Mobile Number <span className="text-danger">*</span></label>
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    name="mobileNumber"
                                                    value={formData.mobileNumber}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fs-6">Gender <span className="text-danger">*</span></label>
                                                <select 
                                                    className="form-select"
                                                    name="gender"
                                                    value={formData.gender}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                >
                                                    <option value="">Select Gender</option>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                    <option value="other">Other</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fs-6">Agent ID <span className="text-danger">*</span></label>
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    name="agentId"
                                                    value={formData.agentId}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fs-6">Password <span className="text-danger">*</span></label>
                                                <input 
                                                    type="password" 
                                                    className="form-control"
                                                    name="password"
                                                    value={formData.password}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fs-6">Referral Code (Optional)</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    name="referedBy"
                                                    value={formData.referedBy}
                                                    onChange={handleChange}
                                                    disabled={loading}
                                                />
                                            </div>
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary text-uppercase py-2 fs-5 w-100 mt-2"
                                                disabled={loading}
                                            >
                                                {loading ? "Creating Account..." : "Create Account"}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                                <Link to={process.env.PUBLIC_URL+"/sign-in"} title="#" className="mt-3">Already registered? <span className="text-secondary text-decoration-underline">Log In</span></Link>
                            </div>
                        </div>
                        <AuthRight />
                    </div>
                </div>
            </div>   
        </>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { registerUser })(Signup);